import { makeLabel } from "../utils/generalUtils";
import { Row, Col } from "./Grid"
import PropTypes from 'prop-types'
import Button from "./Button";
import Icon from "./Icon";
import { useNavigate } from "../hooks/navigateHook";

const LinkLabel = ({ href, text }) => {
    const navigate = useNavigate();

    const handleClick = (e) => {
        e.preventDefault();
        navigate(href, { target: '_blank' });
    };

    return <Button className="p-0 text-start" variant="link" style={{ fontSize: 'smaller' }} onClick={handleClick}>
        <Icon variant="solid" kind="link" style={{ fontSize: '6pt' }} /> {text}
    </Button>
}

/**
 * Provides infrastructure for a conditionally shown label above a control.
 * 
 * This is generally only used in the common component or in project-specific base components
 * that are composited into more complex grid layouts.
 * @component 
 */
export const FloatingLabel = ({hideLabel = false, padding = false, placeholder, required, value, style, href, children}) => {
    const label = makeLabel(placeholder, required);
    const text = value != null && value !== '' && label !== '' ? label : '\u00A0';
    return <div className={ hideLabel && padding ? "p-2" : "px-1" } style={style}>{ hideLabel ? null : <Row>
        <Col>
            {href ?
                <LinkLabel href={href} text={text}></LinkLabel>
                : <span className="fieldLabel">{text}</span>}
        </Col>
    </Row> }
    <Row>
        <Col>
            {children}
        </Col>
    </Row>
    </div>
}

FloatingLabel.propTypes = {
    /**
     * Collapses the floating label used for spacing
     */
    hideLabel: PropTypes.bool,

    /**
     * The label for the control
     */
    placeholder: PropTypes.string,

    /**
     * The value rendreed by the child control(s) - truthy values will result in the label showing
     */
    value: PropTypes.any,

    /**
     * Controls if the required field marker is rendered on the label
     */
    required: PropTypes.bool,

    /**
     * Should the label padding be rendered when the label is hidden
     */
    padding: PropTypes.bool,

    /**
     * An option navigation URL to be followed if the label text is clicked
     */
    href: PropTypes.string,

    /**
     * The control(s) to wrap the label around
     */
    children: PropTypes.node.isRequired,

    /**
     * Custom label styling
     */
    style: PropTypes.object
}